import { useState, useEffect } from "react";
import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer";
import ContentContainer from "../components/ContentContainer";

const AboutPage = () => {
  const apiUrl = import.meta.env.VITE_API_URL_TEXTS;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + "lokultinfo");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  return (
    <Layout
      title="Om Lokult"
      description="Vad är Lokult? Vi finns här för att försöka samla all musik från Strängnäs kommun på ett ställe."
    >
      <MainContainer>
        <section className="m-auto mt-10 bg-[#131313] w-full max-w-4xl overflow-hidden rounded-2xl border border-white/10 shadow-lg">
          <div className="h-1.5 w-full bg-gradient-to-r from-[#0047ff]/60 via-[#0047ff] to-blue-500/70" />
          <div className="p-6 sm:p-10">
            <div className="mb-8 border-b border-white/10 pb-5">
              <p className="text-[10px] font-black tracking-[0.25em] uppercase text-[#0047ff]">
                Om Lokult
              </p>
              <h1 className="mt-2 text-2xl sm:text-3xl font-black text-white uppercase tracking-wider">
                Musikplattformen i Strängnäs
              </h1>
            </div>

            {loading && (
              <div className="rounded-xl border border-white/10 bg-[#181818] px-5 py-6 text-stone-400 text-sm">
                Laddar information...
              </div>
            )}

            {error && (
              <div className="rounded-xl border border-error/40 bg-error/10 px-5 py-6 text-error-content text-sm">
                Ett fel uppstod: {error}
              </div>
            )}

            {!loading && !error && data ? (
              <div
                className="prose prose-invert max-w-xl prose-headings:mb-3 prose-p:my-3 prose-a:text-[#0047ff] text-stone-300 leading-relaxed text-sm sm:text-base"
                dangerouslySetInnerHTML={{ __html: data.data.about }}
              />
            ) : null}

            {!loading && !error && !data && (
              <div className="rounded-xl border border-white/10 bg-[#181818] px-5 py-6 text-stone-400 text-sm">
                Ingen information tillgänglig just nu.
              </div>
            )}
          </div>
        </section>
      </MainContainer>
    </Layout>
  );
};

export default AboutPage;
